import { createAction } from '@reduxjs/toolkit';
import { UserStatus } from '@xbcb/client-types';

export const SET_USER_STATUS = 'SET_USER_STATUS';

export const setUserStatus = createAction<UserStatus>(SET_USER_STATUS);
